import React, { useMemo } from 'react';

import { TPortletWrapperProps } from '@interlayer/js/app/components/system/Portlet/components/PortletWrapper/types';
import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { FILL_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';

import style from '@interlayer/js/components/system/Portlet/Portlet.scss';

export const PortletWrapper: React.FC<TPortletWrapperProps> = ({ children, portletStyle = {} }) => {
    const customStyle = useMemo(() => {
        const result: Record<string, string> = {};

        if (portletStyle.fill === FILL_TYPE.solid && portletStyle.backgroundColor) {
            result.backgroundColor = portletStyle.backgroundColor;
        }

        if (portletStyle.fill === FILL_TYPE.gradient) {
            result.background = `linear-gradient(to bottom, ${portletStyle.startColor}, ${portletStyle.midColor} 53%, ${portletStyle.endColor})`;
        }

        return result;
    }, [portletStyle.backgroundColor, portletStyle.endColor, portletStyle.fill, portletStyle.midColor, portletStyle.startColor]);

    if (!portletStyle.fill) {
        return children;
    }

    return (
        <div
            data-testid="PortletWrapper_container"
            className={clsx(style.portletWithCustomStyle, 'isPortletWithCustomStyle')}
            style={customStyle}
        >
            {children}
        </div>
    );
};

